import { render, staticRenderFns } from "./NativeLandingScreen.vue?vue&type=template&id=49605ceb&scoped=true"
import script from "./NativeLandingScreen.vue?vue&type=script&lang=js"
export * from "./NativeLandingScreen.vue?vue&type=script&lang=js"
import style0 from "./NativeLandingScreen.vue?vue&type=style&index=0&id=49605ceb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49605ceb",
  null
  
)

export default component.exports